module.exports = __webpack_public_path__ + "img/logo.535f8629.png";